/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum LanguageEnum {
    EN_US = 'en-us',
    ES = 'es',
    RU = 'ru',
}